export default __webpack_public_path__ + "static/media/image_8.9ab54153.jpg";